import styled from "styled-components";

export const InputContainer = styled.div`
  width: 100%;
  .input-container {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  textarea {
    width: 100%;
    max-width: 100%;
    resize: none;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 15px;
  }

  .input-container:focus-within label {
    transform: translate(0, -14px) scale(0.8);
    /* color: #0a53e4; */
    font-size: 16px;
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #70707080;
  }

  .input-container .filled {
    transform: translate(0, -14px) scale(0.8);
    /* font-size: 18px; */
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #70707080;
  }
  .react-select__control {
    min-height: 40px;
    border: none;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    box-shadow: none;
    :hover {
      border-color: #e0e0e0;
    }
  }
  .react-select__value-container {
    padding-left: 0;
    padding-right: 0;
  }
  .input-container label {
    position: absolute;
    pointer-events: none;
    transform: translate(-12px, 12px) scale(1);
    transform-origin: top left;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    color: #70707080;
    font-size: 14px;
    /* line-height: 122%; */
    left: 16px;
  }

  .input-container > input {
    /* height: 64px; */
    font-family: "latomedium" !important;
    border-radius: 4px;
    border: none;
    padding: 9px 16px 9px 0;
    font-size: 16px;
    line-height: 1;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }

  /* .input-container input:focus {
    box-shadow: 0 0 0 2px #79b1ff;
  } */
`;
